<template>
  <section class="program">
    <div class="container">
      <header class="section-header">
        <SectionTitle>
          {{ $t("conference.program.title") }}
        </SectionTitle>
        <!-- <div class="section-header__content">
          <div>
            <p class="section-header__subtitle">
              {{ $t("conference.program.subtitle") }}
            </p>
            <p>
              {{ $t("conference.program.text") }}
            </p>
          </div>
          <BaseButton
            :to="`${PATHS.CONFERENCE_REGISTRATION}`"
            target="_blank"
            class="button"
            >{{ $t("conference.program.button") }}</BaseButton
          >
        </div> -->
      </header>

      <div class="timetable" id="program">
        <header class="header">
          <div class="topic-headers">
            <time class="time">Time</time>
            <div class="main-stage">
              <div class="topic-label">
                <Video size="24" /> Truth stage (OFFLINE & VIRTUALLY):
              </div>
              <p class="topic-subj">
                Topic: Contextual propaganda and cognitive resilience
              </p>
            </div>
            <div class="up-stage">
              <div class="topic-label">
                <UserRound size="24" /> Justice Stage (ONLY OFFLINE):
              </div>
              <p class="topic-subj">
                Topic: Modern Instruments of Disinformation
              </p>
            </div>
          </div>
        </header>

        <header class="header--mobile">
          <div class="topic-headers">
            <div class="main-stage">
              <div class="topic-label topic-label--hide-up">
                <Video size="24" /> Truth stage
              </div>
            </div>
            <div class="up-stage">
              <div class="topic-label topic-label--hide-main">
                <UserRound size="24" /> Justice Stage
              </div>
            </div>
          </div>
        </header>

        <div class="schedule">
          <div v-for="(item, index) in SCHEDULE" :key="index" class="time-slot">
            <time class="time">
              {{ item.time }}
            </time>
            <div class="content">
              <div v-if="item.break" class="break-session">
                <time datetime="" class="time--mobile">
                  <Clock size="20" />
                  {{ item.time }}
                </time>
                <p class="speach-title">
                  {{ item.title }}
                </p>
                <p v-if="item.subtitle" class="break-subtitle">
                  {{ item.subtitle }}
                </p>
              </div>
              <template v-else>
                <div v-if="item.mainStage" class="session main-stage-session">
                  <time datetime="" class="time--mobile">
                    <Clock size="20" />
                    {{ item.time }}
                  </time>
                  <p class="stage--mobile">
                    <Video size="20" /> Truth stage (OFFLINE & VIRTUALLY)
                  </p>
                  <h3 class="speach-title">{{ item.mainStage.title }}</h3>
                  <p v-if="item.mainStage.subtitle" class="subtitle">
                    {{ item.mainStage.subtitle }}
                  </p>
                  <div v-if="item.mainStage.speakers" class="speakers">
                    <span
                      v-for="speaker in item.mainStage.speakers"
                      :key="speaker"
                      class="speaker"
                    >
                      <router-link
                        v-if="getSpeakerLink(speaker)"
                        :to="getSpeakerLink(speaker)"
                      >
                        {{ speaker }}
                      </router-link>
                      <span v-else>{{ speaker }}</span>
                    </span>
                  </div>
                  <div v-if="item.mainStage.moderators" class="speakers">
                    <span
                      v-for="moderator in item.mainStage.moderators"
                      :key="moderator"
                      class="speaker"
                    >
                      Moderator:
                      <router-link
                        v-if="getSpeakerLink(moderator)"
                        :to="getSpeakerLink(moderator)"
                      >
                        {{ moderator }}
                      </router-link>
                      <span v-else>{{ moderator }}</span>
                    </span>
                  </div>
                </div>
                <div v-if="item.upStage" class="session up-stage-session">
                  <time datetime="" class="time--mobile">
                    <Clock size="20" />
                    {{ item.time }}
                  </time>
                  <p class="stage--mobile">
                    <UserRound size="20" /> Justice Stage (ONLY OFFLINE)
                  </p>
                  <h3 class="speach-title">{{ item.upStage.title }}</h3>
                  <p v-if="item.upStage.subtitle" class="subtitle">
                    {{ item.upStage.subtitle }}
                  </p>
                  <div v-if="item.upStage.speakers" class="speakers">
                    <span
                      v-for="speaker in item.upStage.speakers"
                      :key="speaker"
                      class="speaker"
                    >
                      <router-link
                        v-if="getSpeakerLink(speaker)"
                        :to="getSpeakerLink(speaker)"
                      >
                        {{ speaker }}
                      </router-link>
                      <span v-else>{{ speaker }}</span>
                    </span>
                  </div>
                  <div v-if="item.upStage.moderators" class="speakers">
                    <span
                      v-for="moderator in item.upStage.moderators"
                      :key="moderator"
                      class="speaker"
                    >
                      Moderator:
                      <router-link
                        v-if="getSpeakerLink(moderator)"
                        :to="getSpeakerLink(moderator)"
                      >
                        {{ moderator }}
                      </router-link>
                      <span v-else>{{ moderator }}</span>
                    </span>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <footer class="schedule__footer">
            <p>
              {{ $t("conference.program.footer") }}
            </p>
            <a
              href="https://de.ui.org.ua/"
              target="_blank"
              title="Ukrainisches Institut"
              class="img-link"
              ><img
                src="@/assets/images/conference/ui-logo.png"
                width="190"
                height="auto"
                alt=""
            /></a>
          </footer>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";

// import BaseButton from "@/components/common/BaseButton.vue";
import SectionTitle from "@/components/common/SectionTitle.vue";
import { Video, UserRound, Clock } from "lucide-vue-next";
import { SCHEDULE } from "@/data/program";
import SPEAKERS from "@/data/speakers";
import { PATHS } from "@/data/nav";

export default {
  name: "ProgramSection",
  components: {
    SectionTitle,
    Video,
    UserRound,
    Clock,
  },
  setup() {
    const route = useRoute();
    const currentLang = ref(route.params.lang);

    const getSpeakerLink = (speakerName) => {
      const speaker = SPEAKERS.find((s) => s.name === speakerName);
      return speaker ? `/${currentLang.value}/${speaker.url}` : null;
    };

    return {
      SCHEDULE,
      PATHS,
      getSpeakerLink,
    };
  },
  // methods: {
  //   toggleMainStage() {
  //     this.showMainStage = !this.showMainStage;
  //   },
  //   toggleUpStage() {
  //     this.showUpStage = !this.showUpStage;
  //   },
  // },
};
</script>

<style scoped>
.section-header {
  display: flex;
  flex-direction: column;
  /* gap: 4rem; */
  gap: clamp(2rem, 1.1485rem + 3.1683vw, 4rem);
}

.section-header__content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 522px;
  margin-left: auto;
}

.section-header__subtitle {
  /* font-size: 1.75rem; */
  font-size: clamp(1.125rem, 0.8589rem + 0.9901vw, 1.75rem);
  line-height: 1.5;
  font-weight: 700;
  margin-bottom: 1rem;
}

.seaction-header__text {
  /* font-size: 1.25rem; */
  font-size: clamp(1rem, 0.8936rem + 0.396vw, 1.25rem);
  line-height: 1.5;
  color: var(--color-off-black);
}

.button {
  position: relative;
}

@media screen and (min-width: 768px) {
  .button::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 314px;
    height: 300px;
    top: -270px;
    left: -260px;
    background-image: url("../../assets/images/conference/register-arrow.svg");
    background-repeat: no-repeat;
    pointer-events: none;
  }
}

.timetable {
  font-family: system-ui, -apple-system, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: var(--spacing-unit);
}

.header {
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--color-gray);
  margin-bottom: 2.5rem;
  margin-top: 2rem;
  padding-left: 0;
  color: var(--color-primary);
}

@media screen and (min-width: 768px) {
  .header--mobile {
    display: none;
  }
  .header {
    margin-top: 10rem;
    padding-top: 1rem;
    position: sticky;
    top: 0;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    transition: all 0.2s ease;
  }

  .scroll-up .header {
    top: 100px;
  }
}

.topic-headers {
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 10px 0;
  align-items: flex-start;
}
.topic-headers .time {
  padding-top: 0;
}
.time--mobile,
.stage--mobile {
  display: none;
  font-size: 0.875rem;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}
.stage--mobile {
  margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
  .header--mobile {
    display: block;
    background-color: var(--color-off-white);
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
  }
  .header--mobile .topic-headers {
    flex-direction: row;
  }

  .time {
    display: none;
  }
  .time--mobile,
  .stage--mobile {
    display: flex;
  }
  .schedule {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}

.topic-headers .main-stage,
.topic-headers .up-stage {
  padding: 0;
}
.topic-headers .main-stage {
  color: var(--main-stage-color);
}

.topic-headers .up-stage {
  color: var(--up-stage-color);
}

.header .time {
  text-transform: uppercase;
}
.topic-label {
  /* font-size: 1.25rem; */
  font-size: clamp(0.875rem, 0.7153rem + 0.5941vw, 1.25rem);
  line-height: 1.5;
  vertical-align: middle;
  margin-bottom: 1rem;
  align-items: center;
  display: flex;
  text-transform: uppercase;
}

.topic-subj {
  font-weight: bold;
  /* font-size: 1.5rem; */
  font-size: clamp(1rem, 0.7871rem + 0.7921vw, 1.5rem);
  line-height: 1.33;
  max-width: 382px;
}

.topic-label svg {
  margin-right: 0.5rem;
}

.topic-headers {
  /* display: flex;
  gap: calc(var(--spacing-unit) * 2); */
}

.main-stage,
.up-stage {
  font-size: 0.9rem;
  font-weight: 500;
  padding: 0.75rem 1.25rem;
  border-radius: var(--border-radius);
  flex: 1;
}

.topic-label {
  opacity: 0.9;
  margin-bottom: 0.25rem;
}

.time-slot {
  display: flex;
  /* gap: calc(var(--spacing-unit) * 2); */
  margin-bottom: 40px;
}

.time {
  font-size: 1.25rem;
  line-height: 1.5;
  margin-right: 40px;
  padding-top: 30px;
  min-width: 108px;
  text-align: right;
}

.content {
  display: flex;
  flex: 1;
  gap: 40px;
}

.session {
  padding: 30px;
  border-radius: 8px;
  color: var(--text-light);
  color: var(--color-off-white);

  transition: all 0.2s ease;
}

.main-stage-session {
  background-color: var(--main-stage-color);
  width: calc((100% - 40px) / 2);
  margin-right: auto;
}

.up-stage-session {
  background-color: var(--up-stage-color);
  width: calc((100% - 40px) / 2);
  margin-left: auto;
}

.break-session {
  width: 100%;
  padding: 30px;
  background-color: var(--color-gray);
  border-radius: 8px;
  color: var(--color-off-black);
  font-size: 1.25rem;
  line-height: 1.5;
}

.break-title {
  font-weight: 500;
}

.break-subtitle {
  margin-top: 0.5rem;
  font-size: 0.9rem;
  white-space: pre-line;
}

.speach-title {
  /* font-size: 1.5rem; */
  font-size: clamp(1.125rem, 0.9653rem + 0.5941vw, 1.5rem);
  margin-bottom: 0;
  line-height: 1.3;
  font-weight: 800;
  font-family: "Helvetica Neue", Arial, Helvetica, sans-serif;
}

.subtitle {
  font-size: clamp(1.125rem, 0.9653rem + 0.5941vw, 1.5rem);
  margin-bottom: 0.75rem;
  font-weight: 400;
  opacity: 0.95;
  line-height: 1.3;
}

.speakers {
  margin-top: 0.75rem;
  font-size: 0.9rem;
  opacity: 0.95;

  display: flex;
  flex-direction: column;
}

.speakers a {
  color: var(--color-off-white);
  font-weight: 700;
}

.speaker {
  padding: 0.15rem 0;
}
.speaker:not(:last-child) {
  margin-bottom: 0.5rem;
}

@media (max-width: 768px) {
  .topic-headers {
    flex-direction: column;
    gap: 2rem;
  }

  .content {
    flex-direction: column;
    gap: 1.5rem;
  }

  .time-slot {
    flex-direction: column;
    gap: calc(var(--spacing-unit) * 0.5);
    margin-bottom: calc(var(--spacing-unit) * 1.5);
  }

  .time {
    font-weight: 500;
    text-align: left;
  }

  .session {
    width: 100%;
  }
}

.schedule__footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  padding-top: 40px;
}

.img-link {
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 0;
}

/* Hover effects */
/* .session:hover {
  transform: translateY(-2px);
} */
</style>
